import * as React from "react";

const GSPSourceInformation = ({ host, domain, sourceURL, imageURL, knownChildAbuseImageArachnid }) => {
  return (
    <div className="geoseearch-photo__source">
      <h2>Source Information:</h2>
      <div className="geoseearch-photo__source-container">
        {!knownChildAbuseImageArachnid ? <>
          <div className="geosearch-photo__host">
            <h5>Host</h5>
            <p>{host}</p>
          </div>
          <div className="geosearch-photo__domain">
            <h5>Domain</h5>
            <p>{domain}</p>
          </div>
          <div className="geosearch-photo__source-url">
            <h5>Source URL</h5>
            <p className="hyphenate">
              <a href={sourceURL}>{sourceURL}</a>
            </p>
          </div>
          <div className="geosearch-photo__image-url">
            <h5>Image URL</h5>
            <p className="hyphenate">
              <a href={imageURL}>{imageURL}</a>
            </p>
          </div>
        </> :
          <div className="geosearch-photo__source-url">
            <p>This photo is related to a child image abuse case</p>
          </div>}
      </div>
    </div>
  );
};

export default GSPSourceInformation;
